import React from 'react';
import {
  Card, CardContent, Box, Typography, Chip, Button, Stack, Divider,
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import { BallDisplay } from './BallPicker';
import { RL_STATUS_TEXT, RL_STATUS_COLOR } from '../../services/realLotteryApi';

export default function OrderCard({ order, onAction }) {
  const history = useHistory();
  const statusColor = RL_STATUS_COLOR[order.status] || 'default';
  const statusText = order.statusText || RL_STATUS_TEXT[order.status] || order.status;

  const isWon = order.status === 'won';
  const isRedeeming = order.status === 'redeeming';
  const isRedeemFailed = order.status === 'redeem_failed';

  return (
    <Card variant="outlined" sx={{ mb: 1.5, borderRadius: 2 }}>
      <CardContent sx={{ pb: 1 }}>
        {/* 头部：期号 + 状态 */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
          <Box>
            <Typography variant="caption" color="text.secondary">
              {order.gameCode === 'ssq' ? '双色球' : order.gameCode} · 第 {order.period} 期
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.3, color: 'text.secondary', fontSize: 11 }}>
              单号：{order.outTradeNo}
            </Typography>
          </Box>
          <Chip label={statusText} color={statusColor} size="small" />
        </Box>

        {/* 投注号码 */}
        <Box sx={{ mb: 1 }}>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
            投注号码
          </Typography>
          <BallDisplay red={order.redBalls} blue={order.blueBall} size={28} />
          <Typography variant="caption" sx={{ ml: 1 }}>
            {order.betCount} 注 × {order.multiple} 倍 · 消耗 {order.costPoints} 积分
          </Typography>
        </Box>

        {/* 开奖号码（如果有） */}
        {order.drawRedBalls && order.drawRedBalls.length > 0 && (
          <Box sx={{ mb: 1 }}>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
              开奖号码（中红 {order.matchRed} 蓝 {order.matchBlue}）
            </Typography>
            <BallDisplay red={order.drawRedBalls} blue={order.drawBlueBall} size={26} />
          </Box>
        )}

        {/* 中奖金额 */}
        {isWon || isRedeeming || order.status === 'redeemed' || isRedeemFailed ? (
          <Box sx={{
            mt: 1, p: 1.2, borderRadius: 1,
            backgroundColor: isWon ? 'rgba(76,175,80,0.08)' : 'rgba(255,152,0,0.08)',
          }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="caption" color="text.secondary">
                  税前 ¥{order.winAmountYuan} {order.taxAmountFen > 0 && `（已扣税 ¥${(order.taxAmountFen/100).toFixed(2)}）`}
                </Typography>
                <Typography variant="h6" color="error" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                  ¥{order.afterTaxAmountYuan}
                </Typography>
              </Box>
              {order.isHugeWin && (
                <Chip label="需线下兑奖" color="warning" size="small" />
              )}
            </Stack>
          </Box>
        ) : null}

        {/* 失败原因 */}
        {order.failReason && (
          <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
            原因：{order.failReason}
          </Typography>
        )}

        <Divider sx={{ my: 1 }} />

        {/* 时间 + 操作 */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="caption" color="text.secondary">
            {order.createdAt ? new Date(order.createdAt).toLocaleString('zh-CN') : ''}
          </Typography>
          <Stack direction="row" spacing={1}>
            <Button
              size="small"
              onClick={() => history.push(`/real-lottery/order/${order.outTradeNo}`)}
            >
              详情
            </Button>
            {(isWon || isRedeemFailed) && !order.isHugeWin && (
              <Button
                size="small"
                variant="contained"
                color="success"
                onClick={() => history.push(`/real-lottery/redeem/${order.outTradeNo}`)}
              >
                立即兑奖
              </Button>
            )}
            {isRedeeming && (
              <Button
                size="small"
                variant="outlined"
                onClick={() => onAction && onAction('refreshRedeem', order)}
              >
                查询打款
              </Button>
            )}
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
}
